module.exports = __webpack_public_path__ + "static/media/rub-out-the-words.0f2c33e8.txt";